import { FC } from 'react'
import { useLockBodyScroll } from '@uidotdev/usehooks'

const BodyScrollLock: FC = () => {
    useLockBodyScroll()
    return (
        <></>
    )
}
export default BodyScrollLock